export enum SnAspectRatio {
  HD = 56.25,
  Square = 100,
  Classic = 66.66,
  Standard = 75,
  Cinemascope = 42.86,
}
